import React from 'react';
import { format } from 'date-fns';
import { camelCaseToTitleCase } from '@leverege/string-util';
import { DateTimeRangePicker } from '@leverege/ui-elements';
import { ModelFactory } from '@leverege/ui-plugin';
import MapViewerModel from "../../shared/models/MapViewerModel.js";
import HistoryModel from "../../shared/renderers/HistoryModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  id: 'molten.mapDataViewer.TimeRange',
  matches: {
    use: 'bottomRightActionBar',
    client: ['MapDataViewer', 'GoogleMapsDataViewer']
  },
  layout: {
    sort: 'aTimeRange'
  },
  handles: context => {
    const {
      clientProps,
      streetView
    } = context;
    const {
      dataViewerCardModel
    } = clientProps;
    return !dataViewerCardModel?.needsDate && streetView !== true;
  },
  customComponent: ({
    context
  }) => {
    const settings = context.clientProps.settings;

    // Find first value or use fallback.
    let Model, layer;
    for (let i = 0; i < settings.layers.length; i++) {
      const tmpLayer = settings.layers[i];
      const tmpModel = ModelFactory.get(tmpLayer);
      if (tmpLayer?.visible && tmpModel?.getNeedsDate?.(tmpLayer)) {
        layer = tmpLayer;
        Model = tmpModel;
        break;
      }
    }
    if (!Model || !layer) {
      return null;
    }
    const value = Model.getRange(layer) || 'last7Days';

    // If ISO strings get passed to date-fns, it breaks. Pass date objects instead.
    if (typeof value === 'object') {
      value.start = new Date(value.start);
      value.end = new Date(value.end);
    }
    const rangeTypes = getDtrpRangeTypes(value);
    return /*#__PURE__*/_jsx(DateTimeRangePicker, {
      variant: "mapTimeRange",
      eventData: {
        context
      },
      value: value,
      onChange: onHistoryModelsUpdate,
      rangeTypes: rangeTypes
    });
  }
};
function onHistoryModelsUpdate(evt) {
  const settings = evt.data.context.clientProps.settings;
  const settingsData = evt.data.context.clientProps.settingsData;
  const onSettingsChange = evt.data.context.clientProps.onSettingsChange;
  const layers = settings.layers.reduce((acc, layer) => {
    const Model = ModelFactory.get(layer);
    if (Model?.getNeedsDate?.(layer)) {
      acc.push(HistoryModel.setRange(layer, evt.value));
    } else {
      acc.push(layer);
    }
    return acc;
  }, []);
  onSettingsChange({
    value: MapViewerModel.setLayers(settings, layers),
    data: settingsData
  });
}
function getDtrpRangeTypes(value) {
  return DateTimeRangePicker.defaultRangeTypes.map(rt => {
    let toggleText;
    if (typeof value === 'object' && rt.isMatch(DateTimeRangePicker.getRange(value))) {
      toggleText = `${format(value.start, 'MMM dd')} - ${format(value.end, 'MMM dd')}`;
    }
    if (typeof value === 'string' && rt.value === value) {
      toggleText = camelCaseToTitleCase(value);
    }
    return {
      ...rt,
      renderer: {
        type: 'toggleButton',
        field: 'toggleText'
      },
      toggleText
    };
  });
}